// extracted by mini-css-extract-plugin
export default {"wrapper":"Astro_wrapper__FQTi1","card":"Astro_card__QIOgf","column":"Astro_column__4qLRD","info":"Astro_info__J3pyv","heading":"Astro_heading__HwEN2","icon":"Astro_icon__VWMJb"};